<template>
  <v-dialog v-model="value" persistent width="500">
    <v-card>
      <v-card-text>
        <p class="title">{{ $t('Link image url') }}</p>
        <div class="text-xs-center">
          <v-radio-group
            color="primary"
            @change="onChangeImgUrl"
            v-model="templinktype"
            row
            class="text-xs-center"
          >
            <v-radio color="primary" :label="$t('None')" :value="'none'"></v-radio>
            <v-radio color="primary" :label="$t('Use image url')" :value="'imglink'"></v-radio>
            <v-radio color="primary" :label="$t('Use custom url')" :value="'customlink'"></v-radio>
          </v-radio-group>
        </div>
        <div v-if="templinktype == 'customlink'" class="form-control">
          <div
            class="form-control"
            :class="{ 'has-error': errors.has('url') }"
            style="padding: 0 10px"
          >
            <input
              class="form-control"
              :data-vv-as="$t('url')"
              v-validate="'required|isUrl'"
              name="url"
              v-model="templink"
              type="text"
              placeholder="Link URL"
            />
            <span class="error--text caption" v-show="errors.has('url')">{{
              errors.first('url')
            }}</span>
          </div>
        </div>
        <div class="text-xs-center">
          <v-btn @click="onCancelLinkUrl" color="grey" outline>{{ $t('cancel') }}</v-btn>
          <v-btn @click="onSaveLinkImgUrl" color="primary" depressed>{{ $t('Save') }}</v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ['value', 'linkurl', 'linktype', 'image_url'],
  data() {
    return {
      templink: '',
      templinktype: ''
    }
  },
  mounted() {
    this.templink = JSON.parse(JSON.stringify(this.linkurl))
    this.templinktype = JSON.parse(JSON.stringify(this.linktype))
    // this.templink = this.linkurl
    // this.templinktype = this.linktype
  },

  methods: {
    onChangeImgUrl(value) {
      if (value == 'imglink') {
        this.templink = this.image_url
      } else {
        this.templink = ''
      }
    },
    onCancelLinkUrl() {
      this.$emit('input', false)
    },
    async onSaveLinkImgUrl() {
      var result = await this.$validator.validateAll()
      if (!result) {
        // do stuff if not valid.
        this.goToErrorInput()
        return false
      }

      this.$emit('onchange', {
        type: 'web_url',
        url: this.templink,
        linktype: this.templinktype
      })
      this.$emit('input', false)
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/elements/GenericLinkImage.vue